<template>
  <div id="m-video" style="width:100%; height:auto;"></div>
</template>

<script>
import playerMixin from '@/mixins/player';

export default {
  name: 'm-player',
  props: {
    src: {
      type: String,
      required: true
    },
    live: {
      type: Boolean,
      default: false
    },
    flag: {
      type: Boolean,
      default: false
    },
    liveStatus: {
      type: Number,
      required: false,
      default: 0
    }
  },
  mixins: [playerMixin],
  data() {
    return {
      url: '',
      living: true
    };
  },
  computed: {
    tip() {
      let tip2048 = '老师还未进入课堂，请耐心等待';
      if (this.liveStatus === 1) {
        tip2048 = '老师还未进入课堂，请耐心等待';
      } else if (this.liveStatus === 2) {
        if (this.haveVideo === false) {
          tip2048 = '当前直播已结束';
        } else {
          tip2048 = '当前直播已结束';
        }
      }
      return tip2048;
    }
  },
  created() {
    this.living = this.live;
    if (this.src) {
      this.url = this.src;
    }
  },
  mounted() {
    this.initPlayer();
    this.showPlayBtn();
  },
  methods: {
    initPlayer() {
      const that = this;
      if (!this.player) {
        const options = {
          autoplay: true, // iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
          width: this.width, // 视频的显示宽度，请尽量使用视频分辨率宽度
          height: this.height, // 视频的显示高度，请尽量使用视频分辨率高度
          x5_playsinline: true,
          listener: function(msg) {
            if (msg.type == 'error') {
              window.setTimeout(function() {
                that.player.load(); //进行重连
              }, 5000);
            }
          }
        };
        // if (this.live) {
        if (this.living) {
          options.live = true;
          options.m3u8 = this.url;
          options.wording = {
            1: this.tip,
            2: this.tip,
            3: '老师还未进入课堂，请耐心等待',
            // 4: '当前直播未开始',
            4: '老师还未进入课堂，请耐心等待',
            13: '当前直播已结束'
          };
        } else {
          options.live = false;
          options.mp4 = this.url;
          options.wording = {
            2: this.tip
          };
        }
        this.player = new TcPlayer('m-video', options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.pause();
          } else {
            setTimeout(() => {
              this.play();
            }, 0);
          }
        });
      } else {
        this.player.load(this.url);
        this.play();
      }
    },
    showPlayBtn() {
      const playBtn = document.querySelector('.vcp-playtoggle');
      if (this.liveStatus === 0) {
        playBtn.style.display = 'block';
      } else {
        playBtn.style.display = 'none';
      }
    },
    play() {
      const element = document.querySelector('#m-video');
      element.style.display = 'block';
      if (this.live) {
        this.liveStatus === 0 && this.player && this.player.play();
      } else {
        this.player && this.player.play();
      }
    },
    pause() {
      this.player && this.player.pause();
      const element = document.querySelector('#m-video');
      setTimeout(() => {
        element.style.display = 'none';
      }, 300);
    }
  },
  watch: {
    src(val) {
      this.url = val;
      this.initPlayer();
    }
  },
  destroyed() {
    this.player.destroy();
    this.player = null;
  }
};
</script>

<style lang="less">
#m-video {
  .vcp-error-tips {
    margin-top: -2.25em;
    font-size: 14px;
  }
}
</style>
